/* BOHOR · Completa tu look — cross-sell compacto en carrito y página de producto.
   Usa el recomendador nativo de Shopify (complementarios; cae a relacionados).
   No toca bohor.js: los botones "+ Agregar" usan el data-quickadd que ya existe. */
(function () {
  "use strict";

  var fmt = function (centavos) {
    return "$" + Math.round(centavos / 100).toLocaleString("es-CO");
  };

  var filaHtml = function (p) {
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf("?") > -1 ? "&" : "?") + "width=160" : "";
    var antes = p.compare_at_price && p.compare_at_price > p.price;
    var unaTalla = p.variants && p.variants.length === 1 && p.variants[0].available;
    var accion = unaTalla
      ? '<button type="button" class="sug-btn" data-quickadd="' + p.variants[0].id + '">+ Agregar</button>'
      : '<a class="sug-btn" href="' + p.url + '">Elegir talla \u2192</a>';
    return (
      '<li class="sug-item">' +
      '<a class="sug-foto" href="' + p.url + '" tabindex="-1">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : "") + "</a>" +
      '<div class="sug-info">' +
      '<a class="sug-nombre" href="' + p.url + '">' + p.title + "</a>" +
      '<span class="sug-precio num">' + fmt(p.price) + (antes ? "<s>" + fmt(p.compare_at_price) + "</s>" : "") + "</span>" +
      "</div>" + accion + "</li>"
    );
  };

  var pintar = function (caja, lista, productos) {
    if (!caja || !lista) return;
    if (!productos.length) { caja.hidden = true; lista.innerHTML = ""; return; }
    lista.innerHTML = productos.map(filaHtml).join("");
    caja.hidden = false;
  };

  var recomendar = function (base, excluir, alTener) {
    var pedir = function (intent) {
      return fetch("/recommendations/products.json?product_id=" + base + "&limit=8&intent=" + intent)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .catch(function () { return { products: [] }; });
    };
    var filtrar = function (d) {
      return (d.products || []).filter(function (p) {
        return p.available && excluir.indexOf(p.id) === -1;
      });
    };
    pedir("complementary").then(function (d) {
      var prods = filtrar(d);
      if (prods.length >= 1) { alTener(prods.slice(0, 3)); return; }
      pedir("related").then(function (d2) { alTener(filtrar(d2).slice(0, 3)); });
    });
  };

  /* ─ Carrito: sugerencias según la última prenda del combo ─ */
  var ultimaFirma = "";
  var actualizarCarrito = function () {
    var caja = document.getElementById("drawer-sugerencias");
    var lista = document.getElementById("drawer-sug-lista");
    if (!caja || !lista) return;
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.item_count) { pintar(caja, lista, []); ultimaFirma = "vacio"; return; }
        var enCarrito = cart.items.map(function (it) { return it.product_id; });
        var base = cart.items[cart.items.length - 1].product_id;
        var firma = base + "|" + enCarrito.join(",");
        if (firma === ultimaFirma) return; /* nada cambió: no re-pedir */
        ultimaFirma = firma;
        recomendar(base, enCarrito, function (prods) { pintar(caja, lista, prods); });
      })
      .catch(function () { /* el drawer sigue funcionando sin sugerencias */ });
  };

  /* ─ Página de producto: sugerencias bajo el botón de compra ─ */
  var iniciarPdp = function () {
    var caja = document.getElementById("pdp-sugerencias");
    var lista = document.getElementById("pdp-sug-lista");
    if (!caja || !lista) return;
    var base = parseInt(caja.getAttribute("data-producto"), 10);
    if (!base) return;
    recomendar(base, [base], function (prods) { pintar(caja, lista, prods); });
  };

  var iniciar = function () {
    var items = document.getElementById("drawer-items");
    if (items && "MutationObserver" in window) {
      new MutationObserver(actualizarCarrito).observe(items, { childList: true });
      actualizarCarrito();
    }
    iniciarPdp();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciar);
  } else {
    iniciar();
  }
})();
